import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_ACADEMIC_INFO_SUMMARY_REQUEST = 'FETCH_ACADEMIC_INFO_SUMMARY_REQUEST';
export const FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS = 'FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS';
export const FETCH_ACADEMIC_INFO_SUMMARY_FAILURE = 'FETCH_ACADEMIC_INFO_SUMMARY_FAILURE';

const buildAcademicInfoSummaryUrl = (groupId) =>
  buildUrl(`/groups/${groupId}/academic-info/summary`);

export function getApiCallState(state, groupId) {
  return ApiCall.find(state, { method: 'GET', url: buildAcademicInfoSummaryUrl(groupId) });
}

export function fetchAcademicInfoSummaryIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildAcademicInfoSummaryUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchAcademicInfoSummary(groupId));
  };
}

export function fetchAcademicInfoSummary(groupId) {
  return (dispatch) => {
    const url = buildAcademicInfoSummaryUrl(groupId);
    const method = 'GET';

    return dispatch(fetchAcademicInfoSummaryRequest()).payload
      .then((response) => dispatch(fetchAcademicInfoSummarySuccess(response)))
      .catch((error) => dispatch(fetchAcademicInfoSummaryFailure(error)));

    function fetchAcademicInfoSummaryRequest() {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_SUMMARY_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
        disableDefault: true,
      });
    }

    function fetchAcademicInfoSummarySuccess(summary) {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS,
        payload: summary,
        url,
        method,
        groupId,
      });
    }

    function fetchAcademicInfoSummaryFailure(error) {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_SUMMARY_FAILURE,
        error,
        url,
        method,
        groupId,
        disableDefault: true,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/AcademicInfo/Summary/actions.js